export type FocusOnElementOptions = {
  scroll?: boolean;
};

export function focusOnElement(element: HTMLElement | null | undefined, { scroll = true }: FocusOnElementOptions = {}): void {
  if (!element) return;

  if (scroll) {
    element.scrollIntoView({ behavior: 'auto', block: 'center' });
  }

  // Adding setTimeout to avoid auto-opening dropdowns on mobile
  setTimeout(() => {
    element.focus({ preventScroll: true });
  }, 0);
}

export default focusOnElement;
